<template>
  <div>

    <!-- separate buttons (for larger viewports) -->
    <v-toolbar class="d-none d-lg-block" density="compact" flat color="transparent">

      <v-spacer />

      <v-btn
        v-for="(action, index) in enabledActions"
        :key="index"
        icon
        :href="action?.href"
        :to="action?.to"
        @click="maybeEmitActionEvent(action)"
        color="action-foreground"
      >
        <v-icon>{{ action.icon }}</v-icon>
        <v-tooltip
          activator="parent"
          location="top"
        >{{ action.label }}</v-tooltip>
      </v-btn>

    </v-toolbar>

    <!-- flyout menu (for smaller viewports) -->
    <div class="d-lg-none">
      <v-menu>

        <template v-slot:activator="{ props }">
          <v-btn v-bind="props"  color="action-foreground" icon>
            <v-icon icon="$actionMenuButton" />
            <v-tooltip activator="parent" :text="$t('titles.actions')" />
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(action, index) in enabledActions"
            :key="index"
            :href="action.href"
            :to="action.to"
            @click="maybeEmitActionEvent(action)"
          >
            <template v-slot:prepend>
              <v-icon :icon="action.icon" />
            </template>
            <v-list-item-title>
              {{ action.label }}
            </v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>
    </div>

  </div>
</template>

<script setup lang="ts">

import { computed } from 'vue'
import type { ActionGroupAction } from '../types/misc'

interface Props {
  actions?: ActionGroupAction[]
}

const props = withDefaults(defineProps<Props>(), {
  actions: () => []
})

const enabledActions = computed(() => {
  return props.actions.filter(a => !(a?.disabled))
})

const emit = defineEmits<{(e: any): void}>()

function maybeEmitActionEvent(action: ActionGroupAction) {
  if (action?.event) {
    emit(action.event)
  }
}

</script>
